import { DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { MenuItem, MessageService, PrimeNGConfig } from 'primeng/api';
import { DataService } from './services/data.service';
import { SwUpdate } from '@angular/service-worker';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { ThemeService } from './services/theme.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  items: MenuItem[];
  title = 'Instrudex';
  showMenu: boolean;
  darkMode: boolean = false;

  constructor(private primengConfig: PrimeNGConfig,
    @Inject(DOCUMENT) public document: Document, 
    public auth: AuthService,
    private swUpdate: SwUpdate,
    public dataService: DataService,
    private router: Router,
    private themeService: ThemeService)
  {
  }
  
  ngOnInit() {
    this.showMenu = false;
    this.BuildMenu();
    this.CheckUpdateSW();
    this.showMenu = !(this.router.url.includes("ops-app") || this.router.url == "/");

    //also subscribe to url changes
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    )
    .subscribe(event => {
      this.showMenu = !(this.router.url.includes("ops-app") || this.router.url == "/");
    });

    this.initStyle();
  }

  initStyle(){
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      this.darkMode = true;
      this.changeStyle();
    }
  }

  BuildMenu(){
    this.items = [
      {
        label: 'Config',
        routerLink: ['config']
      },
      {
        label: 'Dashboard',
        routerLink: ['dashboard']
      },
      {
        label: 'Lists',
        icon: 'pi pi-fw pi-list',
        items: [
          {
            label: 'Accessioning List',
            routerLink: ['accessioning-list']
          },
          {
            label: 'Echo List',
            routerLink: ['echo-list']
          },
          {
            label: 'Isolation List',
            routerLink: ['isolation-list']
          },
          {
            label: 'Lysing List',
            routerLink: ['lysing-list']
          },
          {
            label: 'Tprep List',
            routerLink: ['tprep-list']
          },
        ]
      },
      {
        label: 'Tracker',
        routerLink: ['tracker']
      },
      {
        label: 'Ops App',
        routerLink: ['ops-app']
      }/*,
      {
        label: 'Lab Map',
        routerLink: ['lab-map']
      }*/
    ];
    this.primengConfig.ripple = true;

  }

  CheckUpdateSW(){
    if (this.swUpdate.isEnabled) {
      this.swUpdate.checkForUpdate().then(updateAvailable => {
        if (updateAvailable)
        {
          if(confirm("New version available. Load New Version?")) {
            window.location.reload();
          }
        }
      });
    }        
  }

  changeStyle()
  {
    if (this.darkMode)
      this.themeService.switchTheme("lara-dark-blue");
    else
      this.themeService.switchTheme("lara-light-blue");
  }

}
